import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AirportLookupModule } from '../../common/airport-lookup/airport-lookup.module';
import { NgcCommonModule } from '../../common/common.module';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { ErrorHandlerModule } from '../../common/error-handler/error-handler.module';
import { HelpModalModule } from '../../help-modal/help-modal.module';
import { NgcStoreModule } from '../../store/store.module';
// This Module's Components
import { NavigationCheckinComponent } from './navigation-checkin.component';

@NgModule({
  imports: [
    NgcCommonModule,
    FormsModule,
    DataLayerModule,
    ReactiveFormsModule,
    CommonModule,
    ErrorHandlerModule,
    HelpModalModule,
    ModalModule.forRoot(),
    AirportLookupModule,
    NgcStoreModule
  ],
  declarations: [NavigationCheckinComponent],
  exports: [NavigationCheckinComponent]
})
export class NavigationCheckinModule {}
